import { SecondaryPageLink } from '@/PageManager'
import { generateBech32IdFromATag, tagNameEquals } from '@/lib/tag'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import ExternalLink from '../ExternalLink'

export default function WikiRedirect({ event, className }: { event: Event; className?: string }) {
  const { t } = useTranslation()
  const dTag = useMemo(() => event.tags.find(tagNameEquals('d'))?.[1], [event])
  const aTag = useMemo(() => event.tags.find(tagNameEquals('a')), [event])
  const targetNaddr = useMemo(() => (aTag ? generateBech32IdFromATag(aTag) : undefined), [aTag])
  const [, targetKind, targetPubkey, targetIdentifier] = aTag ? aTag[1].split(':') : []

  return (
    <div className={cn('space-y-2', className)}>
      <div className="font-medium">{t('Wiki redirect')}</div>
      <div className="text-sm text-muted-foreground">
        <span className="font-medium text-foreground">{dTag}</span> {t('redirects to')}
      </div>
      {targetNaddr ? (
        <SecondaryPageLink
          to={`/${targetNaddr}`}
          className="text-primary hover:underline break-words"
          onClick={(e) => e.stopPropagation()}
        >
          {targetIdentifier || targetNaddr}
        </SecondaryPageLink>
      ) : aTag ? (
        <ExternalLink url={aTag[1]} />
      ) : (
        <div className="text-sm text-muted-foreground">
          {targetKind}:{targetPubkey}:{targetIdentifier}
        </div>
      )}
    </div>
  )
}
